class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeDelay = null;
    this.hoverMediaQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
    this.bindHoverHandlers = this.bindHoverHandlers.bind(this);
    this.handleHoverEnter = this.handleHoverEnter.bind(this);
    this.handleHoverLeave = this.handleHoverLeave.bind(this);

    this.bindHoverHandlers();
    this.hoverMediaQuery.addEventListener('change', this.bindHoverHandlers);
  }

  bindHoverHandlers() {
    this.hoverTargets = [this.mainDetailsToggle, this.content];
    this.hoverTargets.forEach((target) => {
      target.removeEventListener('mouseenter', this.handleHoverEnter);
      target.removeEventListener('mouseleave', this.handleHoverLeave);
    });

    if (this.hoverMediaQuery.matches) {
      this.hoverTargets.forEach((target) => {
        target.addEventListener('mouseenter', this.handleHoverEnter);
        target.addEventListener('mouseleave', this.handleHoverLeave);
      });
    } else {
      this.close();
    }
  }

  handleHoverEnter() {
    window.clearTimeout(this.closeDelay);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    }
  }

  handleHoverLeave(event) {
    const relatedTarget = event.relatedTarget;
    if (
      relatedTarget &&
      (this.mainDetailsToggle.contains(relatedTarget) || this.content.contains(relatedTarget))
    ) {
      return;
    }

    this.closeDelay = window.setTimeout(() => {
      this.close();
    }, 200);
  }

  disconnectedCallback() {
    if (this.hoverTargets) {
      this.hoverTargets.forEach((target) => {
        target.removeEventListener('mouseenter', this.handleHoverEnter);
        target.removeEventListener('mouseleave', this.handleHoverLeave);
      });
    }
    this.hoverMediaQuery.removeEventListener('change', this.bindHoverHandlers);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
